import { render, staticRenderFns } from "./generalization.vue?vue&type=template&id=c32ace12&scoped=true&"
import script from "./generalization.vue?vue&type=script&lang=js&"
export * from "./generalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32ace12",
  null
  
)

export default component.exports